module.exports = __webpack_public_path__ + "static/media/Respiratory_Disease_App_recording.64e11ed6.mp4";